module.exports = __webpack_public_path__ + "img/Icon-Symptom-Checker.f31d67ff.svg";